
        var result = require("!!../../../../node_modules/css-loader/index.js!./course-list.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/course-list/course-list.component.css
// module id = 583
// module chunks = 0